import styled from 'styled-components';

// Implementacao do design Usuarios.html (handoff bundle) — modal
// "hairline shell": Scrim + Modal centralizado, head/body/foot com
// borders hairline. Cores via CSS vars (--cco-*). Modal de Usuarios
// tem largura menor (720px) que os outros formularios (880px) porque
// tem so 4 campos.

// ============================================================
// Scrim — overlay full-screen com blur
// ============================================================
export const Scrim = styled.div`
  position: fixed;
  inset: 0;
  z-index: 50;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: grid;
  place-items: center;
  padding: 24px;

  @media (max-width: 720px) {
    padding: 0;
  }
`;

// ============================================================
// Modal — container central com border hairline
// ============================================================
export const Modal = styled.div`
  width: min(720px, 100%);
  max-height: calc(100vh - 48px);
  background: var(--cco-surface);
  border: 1px solid var(--cco-line-strong);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 720px) {
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  }
`;

// ============================================================
// Modal Head — titulo + close button
// ============================================================
export const ModalHead = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 24px var(--cco-pad) 14px;
  border-bottom: 1px solid var(--cco-line);

  @media (max-width: 480px) {
    padding: 12px var(--cco-pad);
  }
`;

export const HeadText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--cco-ink);
`;

export const Desc = styled.div`
  font-size: 13.5px;
  color: var(--cco-ink-mute);
  margin-top: 4px;
`;

export const ReqHint = styled.div`
  font-size: 11.5px;
  color: var(--cco-ink-faint);
  margin-top: 8px;
  letter-spacing: 0.04em;

  .req {
    color: var(--cco-red);
    margin-right: 3px;
  }
`;

export const Close = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: var(--cco-soft-surface);
  border: 1px solid var(--cco-line);
  display: grid;
  place-items: center;
  color: var(--cco-ink-mute);
  transition: all 0.15s;
  flex: none;
  cursor: pointer;

  :hover {
    background: rgba(244, 68, 92, 0.1);
    color: var(--cco-red);
    border-color: rgba(244, 68, 92, 0.4);
  }
`;

// ============================================================
// Modal Body — scroll vertical interno
// ============================================================
export const ModalBody = styled.div`
  padding: 20px var(--cco-pad);
  overflow-y: auto;
  flex: 1;
`;

export const FormGrid = styled.form`
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
`;

// ============================================================
// Field — label + input em coluna
// ============================================================
export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

export const Label = styled.label`
  font-size: 13.5px;
  font-weight: 600;
  color: var(--cco-ink);

  .req {
    color: var(--cco-red);
    margin-left: 2px;
  }
`;

// Estilo comum de input/select — extraido pra reuso em Input e Select.
const inputBase = `
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  height: 44px;
  padding: 0 16px;
  background: var(--cco-soft-surface-2);
  border: 1px solid var(--cco-line);
  border-radius: 999px;
  color: var(--cco-ink);
  font: inherit;
  font-size: 14px;
  outline: none;
  transition: border-color 0.15s, background 0.15s;
  width: 100%;
  /* border-box: sem isso, width:100% + padding 16 + border 1 estourava a
     largura do container e o input vazava pra fora da modal (scroll-x). */
  box-sizing: border-box;

  &::placeholder {
    color: var(--cco-ink-faint);
  }

  &:focus {
    border-color: var(--cco-cyan);
    background: rgba(28, 176, 216, 0.04);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Input = styled.input`
  ${inputBase}
`;

export const Select = styled.select`
  ${inputBase}
  padding-right: 42px;
  cursor: pointer;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'><path fill='rgba(255,255,255,.5)' d='M0 0h12L6 8z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 16px center;

  option {
    background: #0a0a0b;
    color: var(--cco-ink);
  }
`;

export const ErrorMsg = styled.span`
  color: var(--cco-red);
  font-size: 12px;
  margin-top: -2px;
`;

// ============================================================
// EmpresaRow — select 1fr + CheckPill auto
// ============================================================
export const EmpresaRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 14px;
  align-items: center;
`;

export const CheckPill = styled.button.attrs({ type: 'button' })`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 11px 16px;
  border-radius: 999px;
  border: 1px solid
    ${(props) => (props.$on ? 'var(--cco-cyan)' : 'var(--cco-line)')};
  background: ${(props) =>
    props.$on ? 'rgba(28, 176, 216, 0.10)' : 'var(--cco-soft-surface-2)'};
  color: ${(props) => (props.$on ? 'var(--cco-cyan)' : 'var(--cco-ink)')};
  cursor: pointer;
  user-select: none;
  transition: all 0.15s;
  font-size: 13.5px;
  font-weight: 600;
  font-family: inherit;

  :hover {
    background: ${(props) =>
      props.$on ? 'rgba(28, 176, 216, 0.16)' : 'var(--cco-soft-surface)'};
  }
`;

export const CheckBox = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 5px;
  border: 1.5px solid
    ${(props) => (props.$on ? 'var(--cco-cyan)' : 'var(--cco-line-strong)')};
  background: ${(props) => (props.$on ? 'var(--cco-cyan)' : 'transparent')};
  color: ${(props) => (props.$on ? '#0a0a0b' : 'var(--cco-ink)')};
  display: grid;
  place-items: center;
  flex: none;
  transition: all 0.15s;

  svg {
    width: 12px;
    height: 12px;
    opacity: ${(props) => (props.$on ? 1 : 0)};
    transition: opacity 0.15s;
  }
`;

// ============================================================
// Modal Foot — confirm hint + save button
// ============================================================
export const ModalFoot = styled.div`
  padding: 18px var(--cco-pad) 24px;
  border-top: 1px solid var(--cco-line);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  @media (max-width: 480px) {
    padding: 12px var(--cco-pad);
  }
`;

export const ConfirmHint = styled.div`
  color: var(--cco-ink-mute);
  font-size: 13px;
`;

export const SaveBtn = styled.button`
  height: 48px;
  padding: 0 64px;
  background: var(--cco-cyan);
  color: #06151a;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  border-radius: 10px;
  border: 0;
  cursor: pointer;
  transition: filter 0.15s, background 0.15s;
  min-width: 300px;
  font-family: inherit;

  :hover:not(:disabled) {
    background: #3ec0e0;
  }

  :disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

// ============================================================
// Tela de conclusao (sucesso) — exibida apos cadastrar/editar
// ============================================================
export const SuccessWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 24px 0;
`;

export const SuccessIcon = styled.img`
  width: 180px;
  height: 180px;
  object-fit: contain;
`;

export const SuccessText = styled.span`
  color: var(--cco-ink);
  font-size: 18px;
  font-weight: 700;
  text-align: center;
`;
